<app-waiting-module-scoped [localSpinner]="isLoading" [isGlobalSpinner]="true">
</app-waiting-module-scoped>
<app-extended-waiting-module-scoped
  *ngIf="showExtenedLoader"
  (doneLoading)="showHideExtendedLoader()"
  [displayExtendedLoader]="isLoadingExtended"
></app-extended-waiting-module-scoped>
<div class="angular_root">
  <div class="header_area_root">
    <!-- Header -->
    @if (isAuth && storage?.user) {
      <app-header-authenticated
        [showHeader]="isAuth"
        [newMessagesCount]="newMessagesCount"
      ></app-header-authenticated>
    } @else {
      <app-header-not-authenticated
        [newMessagesCount]="newMessagesCount"
      ></app-header-not-authenticated>
    }
  </div>

  <!-- Pages -->
  <div
    id="main_content"
    class="body_area_root"
    [ngClass]="{
      marginTop: showHeaderResult,
      loggedInTrackMobile: showFooterNavigation
    }"
  >
    <div id="back-div" class="back-div"></div>
    <router-outlet></router-outlet>
  </div>

  <!-- Mobile Footer -->
  <div class="footer_area_root">
    @if (showFooterNavigation) {
      <app-footer
        [newMessagesCount]="newMessagesCount"
        [profileImage]="storage?.user?.profileImg"
      ></app-footer>
    }
  </div>

  <!-- Other components -->
  <app-done></app-done>
  <app-info></app-info>
</div>

<router-outlet name="popup"></router-outlet>
